/**
 * Browser mock for Node.js 'module' built-in.
 * This file is used by Vite during client builds to replace the Node.js 'module' package.
 * The actual createRequire function is never called in browser environments
 * because enhancedSecureExecutor.mjs checks isBrowser before using it.
 */
export const createRequire = undefined
